import { WorkspaceInvite } from '@/models/workspace';
import { ColumnDef } from '@tanstack/react-table';
import { InviteTableRowType } from '../types';
import { getInviteActionsColumn } from './InviteActionsColumn';
import { getInviteEmailColumn } from './InviteEmailColumn';
import { getInviteRoleColumn } from './InviteRoleColumn';
import { getInviteStatusColumn } from './InviteStatusColumn';

export const getWorkspaceInvitesTableColumns = (canDelete: boolean, onDelete?: (invite: WorkspaceInvite) => void): ColumnDef<InviteTableRowType>[] => {
  const columns: ColumnDef<InviteTableRowType>[] = [getInviteEmailColumn(), getInviteRoleColumn(), getInviteStatusColumn()];

  if (canDelete && onDelete) {
    columns.push(getInviteActionsColumn({ canDelete, onDelete }));
  }

  return columns;
};
